import React from "react";
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

// Data
import quotesDate from "../../../data/quotes.json";

// Components
import Magnetic from "../../Common/Magnetic/Magnetic";

// Context
import { useCookie } from "../../../context/CookieContext";

// SCSS
import "./Alert.scss";

const Alert = ({ openWindow, setHoveredElement }) => {
  // Cookie, Close...
  const { acceptCookie, declineCookie, showBanner } = useCookie();
  const [isCookieVisible, setIsCookieVisible] = useState(showBanner);

  const [isQuoteVisible, setIsQuoteVisible] = useState(window.innerWidth > 768);

  // Cookie
  useEffect(() => {
    if (showBanner) {
      setIsCookieVisible(true);
    }
  }, [showBanner]);

  // Load Data
  const [quote, setQuote] = useState(null);
  const [minutesAgo, setMinutesAgo] = useState(0);

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * quotesDate.length);
    setQuote(quotesDate[randomIndex]);

    const randomTime = Math.floor(Math.random() * 9) + 1;
    setMinutesAgo(randomTime);
  }, []);

  if (!quote) return null;

  return (
    // Alert
    <AnimatePresence>
      {(isCookieVisible || isQuoteVisible) && (
        <motion.div
          className="Alerts"
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          {/* Cookie */}
          <AnimatePresence>
            {isCookieVisible && (
              <motion.div
                className="Alert Alert--Cookie"
                onClick={() => setIsCookieVisible(false)}
                initial={{ y: 50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 50, opacity: 0 }}
                transition={{
                  type: "spring",
                  stiffness: 100,
                  damping: 15,
                }}
              >
                {/* Title */}
                <div className="Alert__Title">
                  <span className="Alert__Information">Cookie & Privacy</span>
                  <span className="Alert__Time">{minutesAgo + 3}m ago</span>
                </div>

                {/* Content */}
                <div className="Alert__Content">
                  We use cookies to enable YouTube playback.{" "}
                  <span
                    className="Alert__Link"
                    onClick={(e) => {
                      e.stopPropagation();
                      openWindow("privacy-policy");
                    }}
                  >
                    Read our Privacy Policy
                  </span>
                </div>

                {/* Buttons */}
                <div className="Alert__Buttons">
                  <Magnetic
                    as="div"
                    setHoveredElement={setHoveredElement}
                    onClick={() => setHoveredElement(null)}
                  >
                    <button
                      className="Alert__Button Alert__Button--decline"
                      onClick={(e) => {
                        e.stopPropagation();
                        declineCookie();
                        setIsCookieVisible(false);
                      }}
                    >
                      Decline
                    </button>
                  </Magnetic>
                  <Magnetic
                    as="div"
                    setHoveredElement={setHoveredElement}
                    onClick={() => setHoveredElement(null)}
                  >
                    <button
                      className="Alert__Button Alert__Button--accept"
                      onClick={(e) => {
                        e.stopPropagation();
                        acceptCookie();
                        setIsCookieVisible(false);
                      }}
                    >
                      Accept
                    </button>
                  </Magnetic>
                </div>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Quote */}
          <AnimatePresence>
            {isQuoteVisible && (
              <motion.div
                className="Alert Alert--Quote"
                onClick={() => setIsQuoteVisible(false)}
                initial={{ y: 50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 50, opacity: 0 }}
                transition={{
                  type: "spring",
                  stiffness: 100,
                  damping: 15,
                }}
              >
                {/* Title */}
                <div className="Alert__Title">
                  <span className="Alert__Information">
                    {quote.title}, {quote.author}
                  </span>
                  <span className="Alert__Time">{minutesAgo}m ago</span>
                </div>

                {/* Content */}
                <div className="Alert__Content">{quote.quote}</div>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Alert;
